import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConsultationComponent } from './pages/consultation/consultation.component';
import { BannerComponent } from './pages/banner/banner.component';
import { HttpClientModule } from '@angular/common/http';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CareerComponent } from './pages/career/career.component';
import { RewardComponent } from './pages/reward/reward.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { HeaderBgComponent } from './components/header-bg/header-bg.component';
import { FooterBgComponent } from './components/footer-bg/footer-bg.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { ShippingPolicyComponent } from './pages/shipping-policy/shipping-policy.component';
import { TermsOfServiceComponent } from './pages/terms-of-service/terms-of-service.component';
import { ReturnsAndRefundComponent } from './pages/returns-and-refund/returns-and-refund.component';
import { FaqComponent } from './pages/faq/faq.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { AboutUsComponent } from './pages/about-us/about-us.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { IndividualBrandComponent } from './pages/individual-brand/individual-brand.component';
import { TodaysOfferComponent } from './pages/todays-offer/todays-offer.component';
import { MensSectionComponent } from './pages/mens-section/mens-section.component';
import { ComingSoonComponent } from './pages/coming-soon/coming-soon.component';
import { SkinTypeComponent } from './pages/skin-type/skin-type.component';
import { UserComponent } from './pages/user/user.component';
import { SubHeaderCategoryComponent } from './components/sub-header-category/sub-header-category.component';
import { OurCommunityComponent } from './pages/our-community/our-community.component';
import { BlogComponent } from './pages/blog/blog.component';
import { FoyTvComponent } from './pages/foy-tv/foy-tv.component';
import { CancelOrderComponent } from './pages/cancel-order/cancel-order.component';
import { BrandsDirectoryComponent } from './pages/brands-directory/brands-directory.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PreLoadingDirective } from './utils/preloading.directive'
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { AddAddressComponent } from './components/add-address/add-address.component';
import { LoginPopupComponent } from './components/login-popup/login-popup.component';
import { ResponsiveSearchbarComponent } from './components/responsive-searchbar/responsive-searchbar.component';
import { ResponsiveSearchbarBlackBorderComponent } from './components/responsive-searchbar-black-border/responsive-searchbar-black-border.component';
import { BroadCastService, SubHeaderHoverCategoryComponent } from './components/sub-header-hover-category/sub-header-hover-category.component';
import { SubHeaderWhiteHoverCategoryComponent } from './components/sub-header-white-hover-category/sub-header-white-hover-category.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductListComponent } from './pages/product-list/product-list.component';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { IndividualBlogUpdatedComponent } from './pages/individual-blog-updated/individual-blog-updated.component';
import { PaymentstatusComponent } from './components/paymentstatus/paymentstatus.component';
import { ProductDetailUpdatedComponent } from './pages/product-detail-updated/product-detail-updated.component';
import { YourProfileComponent } from './components/your-profile/your-profile.component';
import { MyOrdersComponent } from './components/my-orders/my-orders.component';
import { MyWishlistComponent } from './components/my-wishlist/my-wishlist.component';
import { AddressComponent } from './components/address/address.component';
import { UserYourProfileComponent } from './pages/user-your-profile/user-your-profile.component';
import { UserMyOrdersComponent } from './pages/user-my-orders/user-my-orders.component';
import { UserMyWishlistComponent } from './pages/user-my-wishlist/user-my-wishlist.component';
import { UserAddressComponent } from './pages/user-address/user-address.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { BlogListComponent } from './pages/blog-list/blog-list.component';
import { ProductComponent } from './pages/product/product.component';
import { ProductBoxComponent } from './components/product-box/product-box.component';
import { ProductTypeBeautyComponent } from './pages/product-type-beauty/product-type-beauty.component';
import { HomepageComponent } from './pages/homepage/homepage.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { OrderComponent } from './pages/order/order.component';
import { OrderDetailComponent } from './pages/order-detail/order-detail.component';
import { NeedHelpComponent } from './components/need-help/need-help.component';
import { ProductDetailInvoiceComponent } from './components/product-detail-invoice/product-detail-invoice.component';
import { OfferListComponent } from './components/offer-list/offer-list.component';
import { ProductBoxTwoComponent } from './components/product-box-two/product-box-two.component';
import { BlogListTwoComponent } from './pages/blog-list-two/blog-list-two.component';
import { PaymentMethodasComponent } from './components/payment-methodas/payment-methodas.component';
import { CheckoutNewComponent } from './pages/checkout-new/checkout-new.component';
import { BlogsComponent } from './components/blogs/blogs.component';
import { FoyToastComponent } from './components/foy-toast/foy-toast.component';
import { NoScrollDirective } from './directives/no-scroll.directive';
import { Services } from './utils/utils.service';
import { ListBlogsComponent } from './components/list-blogs/list-blogs.component';

@NgModule({
  declarations: [
    AppComponent,
    ConsultationComponent,
    BannerComponent,
    HeaderComponent,
    FooterComponent,
    CareerComponent,
    RewardComponent,
    ContactUsComponent,
    HeaderBgComponent,
    FooterBgComponent,
    PrivacyPolicyComponent,
    ShippingPolicyComponent,
    TermsOfServiceComponent,
    ReturnsAndRefundComponent,
    FaqComponent,
    SignInComponent,
    SignUpComponent,
    AboutUsComponent,
    IndividualBrandComponent,
    TodaysOfferComponent,
    MensSectionComponent,
    ComingSoonComponent,
    SkinTypeComponent,
    UserComponent,
    SubHeaderCategoryComponent,
    OurCommunityComponent,
    BlogComponent,
    FoyTvComponent,
    CancelOrderComponent,
    BrandsDirectoryComponent,
    PreLoadingDirective,
    AddAddressComponent,
    LoginPopupComponent,
    ResponsiveSearchbarComponent,
    ResponsiveSearchbarBlackBorderComponent,
    SubHeaderHoverCategoryComponent,
    SubHeaderWhiteHoverCategoryComponent,
    ProductListComponent,
    IndividualBlogUpdatedComponent,
    PaymentstatusComponent,
    ProductDetailUpdatedComponent,
    YourProfileComponent,
    MyOrdersComponent,
    MyWishlistComponent,
    AddressComponent,
    UserYourProfileComponent,
    UserMyOrdersComponent,
    UserMyWishlistComponent,
    UserAddressComponent,
    ConfirmationComponent,
    BlogListComponent,
    ProductComponent,
    ProductBoxComponent,
    ProductTypeBeautyComponent,
    HomepageComponent,
    ProfileComponent,
    OrderComponent,
    OrderDetailComponent,
    NeedHelpComponent,
    ProductDetailInvoiceComponent,
    OfferListComponent,
    ProductBoxTwoComponent,
    BlogListTwoComponent,
    PaymentMethodasComponent,
    CheckoutNewComponent,
    BlogsComponent,
    FoyToastComponent,
    NoScrollDirective,
    ListBlogsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CarouselModule,
    NgHttpLoaderModule.forRoot(),
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    InfiniteScrollModule,
    AngularEditorModule,
    LazyLoadImageModule,
    NgbModule,
    ToastrModule.forRoot({
      timeOut: 1500, // 15 seconds
      closeButton: true,
      progressBar: true,
    }),
  ],
  providers: [
     BroadCastService, ToastrService,Services],
  bootstrap: [AppComponent]
})
export class AppModule { }
